import React, { Component } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';

class DatePickerComponent extends Component {
    handleChange = (newValue) => {
        const { onChange } = this.props;
        onChange(newValue ? newValue.toISOString() : null);
    };

    render() {
        const { value, label, ...rest } = this.props;
        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    sx={{ flex: 1 }}
                    label={label}
                    value={value ? dayjs(value) : null}
                    onChange={this.handleChange}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                    {...rest}
                />
            </LocalizationProvider>
        );
    }
}

export default DatePickerComponent;